export default __webpack_public_path__ + "static/media/lake.208ceab3.jpg";